import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceiveDialogComponent } from './receive-dialog.component';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { ReactiveFormsModule } from '@angular/forms';
import { InputSearchScannerModule } from 'src/app/shared/components/input-search-scanner/input-search-scanner.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { SelectedNdcInputModule } from 'src/app/shared/components/selected-ndc-input/selected-ndc-input.module';
import { EnterOrderModule } from 'src/app/shared/components/enter-order/enter-order.module';
import { MultipleDrugsDialogBaseModule } from '../multiple-drugs-dialog-base/multiple-drugs-dialog-base.module';
import { DrugsProcessingService } from '../drugs-processing.service';



@NgModule({
  declarations: [ReceiveDialogComponent],
  imports: [
    CommonModule,
    ButtonModule,
    InputModule,
    InputSearchScannerModule,
    ReactiveFormsModule,
    DialogModule,
    SelectedNdcInputModule,
    EnterOrderModule,
    MultipleDrugsDialogBaseModule
  ], 
  providers: [DrugsProcessingService],
  exports: [ReceiveDialogComponent]
})
export class ReceiveDialogModule { }
